require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./context"), require("./link"), require("./paragraph"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./context", "./link", "./paragraph"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./context"), require("./link"), require("./paragraph")) : factory(root["./utils"], root["./context"], root["./link"], root["./paragraph"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__21__, __WEBPACK_EXTERNAL_MODULE__26__, __WEBPACK_EXTERNAL_MODULE__61__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[25],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, "ba-common-flyout{display:inline-block}.ba-common-flyout{position:relative;display:inline-block}.ba-common-flyout__label{display:inline-block}.ba-common-flyout__label:hover{cursor:pointer}.ba-common-flyout__container{background-clip:padding-box;border-top-color:rgba(0,0,0,.1);line-height:1.42857143;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;line-break:auto;border:1px solid rgba(0,0,0,.1);position:absolute;opacity:1;margin:auto;background-color:#fff;height:auto;opacity:1;z-index:9001;box-shadow:0 2px 8px 0 rgba(0,0,0,.1)}.ba-common-flyout__container .ba-common-flyout-arrow{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid;border-width:11px;z-index:-1}@media screen and (-ms-high-contrast: active){.ba-common-flyout__container .ba-common-flyout-arrow{border-color:#000}}.ba-common-flyout__container .ba-common-flyout-arrow::before{box-sizing:border-box;position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid;border-width:10px;bottom:-10px;left:1px;content:\" \"}@media screen and (-ms-high-contrast: active){.ba-common-flyout__container .ba-common-flyout-arrow::before{border-color:#000}}.ba-common-flyout__container:focus{outline:none}.ba-common-flyout__container.is-hidden{visibility:hidden}.ba-common-flyout__container.padding-none{padding:0}.ba-common-flyout__container.padding-default{padding:16px;width:300px;text-align:center}[dir=ltr].ba-common-flyout__container__title{text-align:left}[dir=rtl].ba-common-flyout__container__title{text-align:right}[dir=ltr] .ba-common-flyout__container__title,.ba-common-flyout__container__title{text-align:left}[dir=rtl] .ba-common-flyout__container__title{text-align:right}.ba-common-flyout__container__title .ba-common-paragraph{display:inline-block;margin:0;width:240px;color:#161616;font-size:14px}.ba-common-flyout__container__textContent .ba-common-paragraph{word-wrap:break-word;margin-top:4px;line-height:1.5;font-weight:regular;color:#525252;font-size:14px}[dir=ltr].ba-common-flyout__container__textContent .ba-common-paragraph{text-align:left}[dir=rtl].ba-common-flyout__container__textContent .ba-common-paragraph{text-align:right}[dir=ltr] .ba-common-flyout__container__textContent .ba-common-paragraph,.ba-common-flyout__container__textContent .ba-common-paragraph{text-align:left}[dir=rtl] .ba-common-flyout__container__textContent .ba-common-paragraph{text-align:right}.ba-common-flyout__container__textContent.without-link .ba-common-paragraph{margin-bottom:0px;word-wrap:break-word}[dir=ltr].ba-common-flyout__container__link{text-align:left}[dir=rtl].ba-common-flyout__container__link{text-align:right}[dir=ltr] .ba-common-flyout__container__link,.ba-common-flyout__container__link{text-align:left}[dir=rtl] .ba-common-flyout__container__link{text-align:right}.ba-common-flyout__container__link .ba-common-link{font-size:small;margin:0}.ba-common-flyout__container{z-index:9001}.ba-common-flyout-arrow.is-right{top:11px;left:-11px;border-right-color:rgba(0,0,0,.1);border-left-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-right{border-right-color:rgba(255,255,255,.1)}}.ba-common-flyout-arrow.is-right:before{border-right-color:#fff;border-left-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-right:before{border-right-color:#fff}}.ba-common-flyout-arrow.is-rightBottom{top:11px;left:-11px;border-right-color:rgba(0,0,0,.1);border-left-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-rightBottom{border-right-color:rgba(255,255,255,.1)}}.ba-common-flyout-arrow.is-rightBottom:before{border-right-color:#fff;border-left-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-rightBottom:before{border-right-color:#fff}}.ba-common-flyout-arrow.is-rightCentred{bottom:calc(50% - 10px);left:-11px;border-right-color:rgba(0,0,0,.1);border-left-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-rightCentred{border-right-color:rgba(255,255,255,.1)}}.ba-common-flyout-arrow.is-rightCentred:before{border-right-color:#fff;border-left-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-rightCentred:before{border-right-color:#fff}}.ba-common-flyout-arrow.is-rightTop{bottom:11px;left:-11px;border-right-color:rgba(0,0,0,.1);border-left-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-rightTop{border-right-color:rgba(255,255,255,.1)}}.ba-common-flyout-arrow.is-rightTop:before{border-right-color:#fff;border-left-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-rightTop:before{border-right-color:#fff}}.ba-common-flyout-arrow.is-left{top:11px;right:-11px;border-right-width:0;border-left-color:rgba(0,0,0,.1)}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-left{border-left-color:rgba(255,255,255,.1)}}.ba-common-flyout-arrow.is-left:before{left:-11px;border-left-color:#fff;border-right-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-left:before{border-left-color:#fff}}.ba-common-flyout-arrow.is-leftBottom{top:11px;right:-11px;border-right-width:0;border-left-color:rgba(0,0,0,.1)}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-leftBottom{border-left-color:rgba(255,255,255,.1)}}.ba-common-flyout-arrow.is-leftBottom:before{left:-11px;border-left-color:#fff;border-right-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-leftBottom:before{border-left-color:#fff}}.ba-common-flyout-arrow.is-leftTop{bottom:11px;right:-11px;border-right-width:0;border-left-color:rgba(0,0,0,.1)}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-leftTop{border-left-color:rgba(255,255,255,.1)}}.ba-common-flyout-arrow.is-leftTop:before{left:-11px;border-left-color:#fff;border-right-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-leftTop:before{border-left-color:#fff}}.ba-common-flyout-arrow.is-leftCentred{bottom:calc(50% - 10px);right:-11px;border-right-width:0;border-left-color:rgba(0,0,0,.1)}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-leftCentred{border-left-color:rgba(255,255,255,.1)}}.ba-common-flyout-arrow.is-leftCentred:before{left:-11px;border-left-color:#fff;border-right-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-leftCentred:before{border-left-color:#fff}}.ba-common-flyout-arrow.is-top,.ba-common-flyout-arrow.is-topLeft,.ba-common-flyout-arrow.is-topRightStart{bottom:-11px;right:11px;border-top-color:rgba(0,0,0,.1);border-bottom-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-top,.ba-common-flyout-arrow.is-topLeft,.ba-common-flyout-arrow.is-topRightStart{border-top-color:rgba(255,255,255,.1)}}.ba-common-flyout-arrow.is-top:before,.ba-common-flyout-arrow.is-topLeft:before,.ba-common-flyout-arrow.is-topRightStart:before{bottom:1px;margin-left:-11px;border-top-color:#fff;border-bottom-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-top:before,.ba-common-flyout-arrow.is-topLeft:before,.ba-common-flyout-arrow.is-topRightStart:before{border-top-color:#fff}}.ba-common-flyout-arrow.is-topCentred{bottom:-11px;left:calc(50% - 10px);border-top-color:rgba(0,0,0,.1);border-bottom-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-topCentred{border-top-color:rgba(255,255,255,.1)}}.ba-common-flyout-arrow.is-topCentred:before{bottom:1px;margin-left:-11px;border-top-color:#fff;border-bottom-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-topCentred:before{border-top-color:#fff}}.ba-common-flyout-arrow.is-topRight,.ba-common-flyout-arrow.is-topLeftStart{bottom:-11px;left:11px;border-top-color:rgba(0,0,0,.1);border-bottom-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-topRight,.ba-common-flyout-arrow.is-topLeftStart{border-top-color:rgba(255,255,255,.1)}}.ba-common-flyout-arrow.is-topRight:before,.ba-common-flyout-arrow.is-topLeftStart:before{bottom:1px;margin-left:-11px;border-top-color:#fff;border-bottom-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-topRight:before,.ba-common-flyout-arrow.is-topLeftStart:before{border-top-color:#fff}}.ba-common-flyout-arrow.is-bottom,.ba-common-flyout-arrow.is-bottomLeft,.ba-common-flyout-arrow.is-bottomRightStart{top:-11px;right:11px;border-top-width:0;border-bottom-color:rgba(0,0,0,.1)}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-bottom,.ba-common-flyout-arrow.is-bottomLeft,.ba-common-flyout-arrow.is-bottomRightStart{border-bottom-color:rgba(255,255,255,.1)}}.ba-common-flyout-arrow.is-bottom:before,.ba-common-flyout-arrow.is-bottomLeft:before,.ba-common-flyout-arrow.is-bottomRightStart:before{top:1px;margin-left:-11px;border-bottom-color:#fff;border-top-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-bottom:before,.ba-common-flyout-arrow.is-bottomLeft:before,.ba-common-flyout-arrow.is-bottomRightStart:before{border-bottom-color:#fff}}.ba-common-flyout-arrow.is-bottomRight,.ba-common-flyout-arrow.is-bottomLeftStart{top:-11px;left:11px;border-top-width:0;border-bottom-color:rgba(0,0,0,.1)}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-bottomRight,.ba-common-flyout-arrow.is-bottomLeftStart{border-bottom-color:rgba(255,255,255,.1)}}.ba-common-flyout-arrow.is-bottomRight:before,.ba-common-flyout-arrow.is-bottomLeftStart:before{top:1px;margin-left:-11px;border-bottom-color:#fff;border-top-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-bottomRight:before,.ba-common-flyout-arrow.is-bottomLeftStart:before{border-bottom-color:#fff}}.ba-common-flyout-arrow.is-bottomCentred{top:-11px;left:calc(50% - 10px);border-top-width:0;border-bottom-color:rgba(0,0,0,.1)}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-bottomCentred{border-bottom-color:rgba(255,255,255,.1)}}.ba-common-flyout-arrow.is-bottomCentred:before{top:1px;margin-left:-11px;border-bottom-color:#fff;border-top-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-bottomCentred:before{border-bottom-color:#fff}}", ""]);

// exports
exports.locals = {
	"flyoutClassName": "\"ba-common-flyout\""
};

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(11));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _paragraph = _interopRequireDefault(__webpack_require__(61));

var _link = _interopRequireDefault(__webpack_require__(26));

var _Flyout = _interopRequireDefault(__webpack_require__(324));

var _FlyoutHelperFunctions = _interopRequireDefault(__webpack_require__(325));

var _flyoutPosition = __webpack_require__(62);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const {
  enableFocusLoop,
  disableFocusLoop
} = _utils.domUtils;

const flyoutClassName = _Flyout.default.flyoutClassName.replace(/"/g, '');

const {
  sanitize
} = _utils.propsUtils;

function triggerNodePropValidator(props, propName, componentName) {
  if (props.triggerNode !== undefined && props.domNodeToAttachTo === undefined) {
    return new Error(`Invalid prop '${propName}' supplied to '${componentName}'. If a 'triggerNode' argument is passed, a 'domNodeToAttachTo' argument must also be passed.`);
  }

  return null;
}

class Flyout extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "setFlyoutRef", flyout => {
      const {
        startingFocusIndex
      } = this.props;
      this._flyout = flyout;

      if (this._flyout) {
        enableFocusLoop(this._flyout, startingFocusIndex);
      }
    });
    (0, _defineProperty2.default)(this, "_onClose", event => {
      if (this._flyout && document.contains(event.target) && !this._flyout.contains(event.target) && this._triggerNode.contains && (this.props.fixedPosition || !this._triggerNode.contains(event.target))) {
        this.props.onClose();
      }
    });
    (0, _defineProperty2.default)(this, "_onKeyDown", e => {
      if (e.keyCode === 27) {
        e.stopPropagation();
        this.props.onClose();
      }
    });
    (0, _defineProperty2.default)(this, "_onResize", () => {
      // Only handle the case when window width has actually changed because iPad would send unexpected
      // resize event whenever there is a scrolling occures;
      if (this.isIPad && this.windowWidth === window.innerWidth) {
        return;
      }

      this.windowWidth = window.innerWidth;

      this._updateLocation();
    });
    (0, _defineProperty2.default)(this, "_updateLocation", () => {
      if (this._flyout) {
        const options = {
          arrow: this._arrow,
          offset: this.props.offset,
          domNodeToAttachTo: this.props.domNodeToAttachTo
        };
        const specs = (0, _FlyoutHelperFunctions.default)(this._triggerNode, this._flyout, this.props.placement, options, this.props.candidatePlacement);
        this.setState(() => ({
          top: specs.top,
          left: specs.left,
          width: this._flyoutBox.width,
          height: this._flyoutBox.height,
          placement: specs.placement,
          hidden: specs.invalid,
          isMounted: true
        }));
      }
    });
    (0, _defineProperty2.default)(this, "_isFixedPosititonDefined", () => this.props.fixedPosition != null);
    this.state = {
      placement: props.placement,
      hidden: false,
      isMounted: false
    };
    this._triggerNode = props.triggerNode;
    this.windowWidth = window.innerWidth;
    this.isIPad = navigator.userAgent.match(/iPad/i) !== null;
  }

  componentDidMount() {
    const {
      onClose
    } = this.props;
    this._flyoutBox = this._flyout.getBoundingClientRect();
    if (!this._triggerNode) this._triggerNode = this._flyout.parentNode;

    if (this._isFixedPosititonDefined()) {
      this._updateFixedPosition();
    } else {
      this._updateLocation();
    }

    window.addEventListener('resize', this._onResize);

    if (onClose) {
      document.addEventListener('mousedown', this._onClose);
      document.addEventListener('touchstart', this._onClose);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      placement,
      isMounted,
      left,
      top
    } = this.state;
    this._flyoutBox = this._flyout.getBoundingClientRect();

    if (!this._isFixedPosititonDefined() && (prevState.placement !== placement || prevState.isMounted !== isMounted || prevState.top !== top || prevState.left !== left || prevState.width !== this._flyoutBox.width || prevState.height !== this._flyoutBox.height)) {
      this._updateLocation();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._onResize);

    if (this.props.onClose) {
      document.removeEventListener('mousedown', this._onClose);
      document.removeEventListener('touchstart', this._onClose);
    }

    disableFocusLoop(this._flyout);
  }
  /**
   * A ref callback called when flyout is mounted or unmounted.
   * @param {Element} flyout The flyout element being mounted/mounted.
   */


  _updateFixedPosition() {
    const {
      fixedPosition: position
    } = this.props;

    const containerRect = this._flyout.getBoundingClientRect();

    const width = containerRect.width + 3;
    const height = containerRect.height + 3;
    let left;

    if (window.innerWidth - position.x < width) {
      left = window.innerWidth - width;
    } else {
      left = position.x;
    }

    let top;

    if (window.innerHeight - position.y < height) {
      top = window.innerHeight - height;
    } else {
      top = position.y;
    }

    this.setState({
      top,
      left
    });
  }

  _title(title) {
    if (typeof title === 'string') {
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-tid": "ba-common-flyout__title",
        className: `${flyoutClassName}__container__title`
      }, /*#__PURE__*/_react.default.createElement(_paragraph.default, {
        fontWeight: "bold"
      }, " ", title, " "));
    }

    return title;
  }

  _textContent(text) {
    const {
      href,
      link
    } = this.props;
    const noLinkClass = href || link ? '' : ' without-link';

    if (typeof text === 'string') {
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-tid": "ba-common-flyout__text",
        className: `${flyoutClassName}__container__textContent${noLinkClass}`
      }, /*#__PURE__*/_react.default.createElement(_paragraph.default, null, " ", text, " "));
    }

    return text;
  }

  _link(href, linkName, link) {
    if (!link && href && linkName) {
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-tid": "ba-common-flyout__link",
        className: `${flyoutClassName}__container__link`
      }, /*#__PURE__*/_react.default.createElement(_link.default, {
        target: "_blank",
        href: href,
        tabIndex: "0"
      }, linkName));
    }

    return link;
  }

  render() {
    const {
      padding,
      hideArrow,
      children,
      domNodeToAttachTo,
      className,
      title,
      textContent,
      link,
      href,
      linkName,
      style,
      ...others
    } = this.props;
    const {
      top,
      left,
      placement,
      hidden,
      isMounted
    } = this.state;
    const classNames = `${(0, _utils.classnames)(`${flyoutClassName}__container`, {
      [`${placement}`]: placement,
      [`padding-${padding}`]: padding,
      hidden
    })}${linkName || link ? ' has-link' : ' no-link'}`;
    const arrowProps = {
      className: (0, _utils.classnames)('ba-common-flyout-arrow', {
        [`${placement}`]: placement
      }),
      ref: node => {
        this._arrow = node;
      }
    };
    const positions = {
      position: this._isFixedPosititonDefined() || !isMounted ? 'fixed' : 'absolute',
      top,
      left
    };
    const flyoutProps = { ...sanitize(others, Flyout),
      className: `${classNames} ${className}`,
      style: { ...positions,
        ...style
      },
      onKeyDown: this._onKeyDown,
      tabIndex: '0',
      ref: this.setFlyoutRef
    };

    const flyout = /*#__PURE__*/_react.default.createElement("div", flyoutProps, title && this._title(title), textContent && this._textContent(textContent), (href || link) && this._link(href, linkName, link), children, !hideArrow && /*#__PURE__*/_react.default.createElement("div", arrowProps));

    return domNodeToAttachTo && isMounted ? _reactDom.default.createPortal(flyout, domNodeToAttachTo) : flyout;
  }

}

exports.default = Flyout;
(0, _defineProperty2.default)(Flyout, "propTypes", {
  placement: _propTypes.default.string,
  candidatePlacement: _propTypes.default.array,
  hideArrow: _propTypes.default.bool,
  padding: _propTypes.default.string,
  children: _propTypes.default.node,

  /** customPropTypes: Element */
  triggerNode: _propTypes.default.instanceOf(Element) && triggerNodePropValidator,
  domNodeToAttachTo: _propTypes.default.instanceOf(Element),
  className: _propTypes.default.string,
  offset: _propTypes.default.number,
  onClose: _propTypes.default.func,
  // also allows to pass a react element
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  textContent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  link: _propTypes.default.element,
  href: _propTypes.default.string,
  linkName: _propTypes.default.string,
  style: _propTypes.default.object,
  startingFocusIndex: _propTypes.default.number,
  fixedPosition: _propTypes.default.shape({
    x: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
    y: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired
  })
});
(0, _defineProperty2.default)(Flyout, "defaultProps", {
  placement: 'right',
  className: '',
  style: {},
  candidatePlacement: _flyoutPosition.POSITIONS,
  startingFocusIndex: -1
});

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__21__;

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__26__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(323);


/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.FlyoutPosition = void 0;

var _Flyout = _interopRequireDefault(__webpack_require__(172));

exports.default = _Flyout.default;
exports.Flyout = _Flyout.default;

var _ContextFlyout = _interopRequireDefault(__webpack_require__(326));

exports.ContextFlyout = _ContextFlyout.default;

var FlyoutPosition = _interopRequireWildcard(__webpack_require__(62));

exports.FlyoutPosition = FlyoutPosition;

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Flyout_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(108);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Flyout_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Flyout_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Flyout_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Flyout_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getValidPlacement = getValidPlacement;
exports.default = getSpecs;

var _utils = __webpack_require__(5);

var _flyoutPosition = __webpack_require__(62);

/* eslint-disable no-param-reassign */

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: @ba/ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const {
  getNearestPositionedParent
} = _utils.domUtils; // Commonly used variables

const defaultSpecs = {
  bottom: 0,
  height: 0,
  left: 0,
  right: 0,
  top: 0,
  width: 0
};
const invalidSpecs = { ...defaultSpecs,
  invalid: true,
  placement: _flyoutPosition.RIGHT
};
const shiftArrowInPixel = 23;
/*
 **
 ** This utility has been created to deal with a rare intermittent issue we
 ** encountered where getBoundingClientRect() is not returning all the data
 ** points it should be (ie: it returned only { width: 100, left: 0 }).
 **
 ** This would cause us to use 'undefined' in our calculations and anything + 'undefined' = NaN.
 ** Using NaN in the React lifecycles would throw them into a tizzy, blowing the stack.
 **
 ** Also note, according to the MDN Web Docs it is unsafe to deconstruct the properties
 ** returned in domRect, that is why all six properties are expliclty being set.
 */

const getBoundingClientRectWithDefaults = node => {
  var _node$getBoundingClie, _domRect$bottom, _domRect$height, _domRect$left, _domRect$right, _domRect$top, _domRect$width;

  const domRect = (_node$getBoundingClie = node == null ? void 0 : node.getBoundingClientRect()) != null ? _node$getBoundingClie : {};
  return {
    bottom: (_domRect$bottom = domRect.bottom) != null ? _domRect$bottom : defaultSpecs.bottom,
    height: (_domRect$height = domRect.height) != null ? _domRect$height : defaultSpecs.height,
    left: (_domRect$left = domRect.left) != null ? _domRect$left : defaultSpecs.left,
    right: (_domRect$right = domRect.right) != null ? _domRect$right : defaultSpecs.right,
    top: (_domRect$top = domRect.top) != null ? _domRect$top : defaultSpecs.top,
    width: (_domRect$width = domRect.width) != null ? _domRect$width : defaultSpecs.width
  };
}; // Determines base top/left value to use, based off of four situations: Rendered normally (without portal) where trigger has position static,
// rendered normally where trigger has position other than static, added to domNode with position static, or added to domNode with position other than static


function getStartingOffset(positionedAncestorLocation, triggerNode, triggerRectOffset, nearestRectOffset, scrollTopOffset, domNodeToAttachTo, domNodeToAttachToRectOffset) {
  if (domNodeToAttachToRectOffset && window.getComputedStyle(domNodeToAttachTo).getPropertyValue('position') === 'static') {
    return positionedAncestorLocation ? triggerRectOffset - positionedAncestorLocation : triggerRectOffset + scrollTopOffset;
  } else if (typeof domNodeToAttachToRectOffset !== 'undefined') {
    return triggerRectOffset - domNodeToAttachToRectOffset - domNodeToAttachTo.clientTop;
  } else if (window.getComputedStyle(triggerNode).getPropertyValue('position') === 'static') {
    return triggerRectOffset - nearestRectOffset;
  }

  return 0;
}

function validateSpace(orientation, startingSpace, containerRect, triggerRect, options) {
  switch (orientation) {
    case _flyoutPosition.TOP:
      startingSpace -= containerRect.height;

      if (options.arrow) {
        startingSpace -= getBoundingClientRectWithDefaults(options.arrow).height;
      }

      if (typeof options.offset !== 'undefined') {
        startingSpace -= options.offset;
      }

      return startingSpace;

    case _flyoutPosition.BOTTOM:
      startingSpace += triggerRect.height;
      startingSpace += containerRect.height;

      if (options.arrow) {
        startingSpace += getBoundingClientRectWithDefaults(options.arrow).height;
      }

      if (typeof options.offset !== 'undefined') {
        startingSpace += options.offset;
      }

      return startingSpace;

    case _flyoutPosition.LEFT:
      startingSpace -= containerRect.width;

      if (options.arrow) {
        startingSpace -= getBoundingClientRectWithDefaults(options.arrow).width;
      }

      if (typeof options.offset !== 'undefined') {
        startingSpace -= options.offset;
      }

      return startingSpace;

    case _flyoutPosition.RIGHT:
      startingSpace += triggerRect.width;
      startingSpace += containerRect.width;

      if (options.arrow) {
        startingSpace += getBoundingClientRectWithDefaults(options.arrow).width;
      }

      if (typeof options.offset !== 'undefined') {
        startingSpace += options.offset;
      }

      return startingSpace;

    default:
      return startingSpace;
  }
}

function getValidPlacement(flyoutTrigger, flyoutContainer, placement, candidatePlacement, options) {
  const containerRect = getBoundingClientRectWithDefaults(flyoutContainer);
  const triggerRect = getBoundingClientRectWithDefaults(flyoutTrigger);
  const shiftArrow = options.arrow ? shiftArrowInPixel : 0;
  let arrowRect;
  if (options.arrow) arrowRect = getBoundingClientRectWithDefaults(options.arrow);
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop; // default initialization is for window

  let startingTop = triggerRect.top;
  let startingLeft = triggerRect.left;
  let heightToCheck = window.innerHeight;
  let widthToCheck = window.innerWidth;

  if (options.body === 'page') {
    const {
      body
    } = document;
    const html = document.documentElement;
    const pageHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.offsetHeight);
    const pageWidth = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.offsetWidth);
    startingTop = triggerRect.top + scrollTop;
    startingLeft = triggerRect.left + scrollLeft;
    heightToCheck = pageHeight;
    widthToCheck = pageWidth;
  }

  let result = {
    top: 0,
    left: 0,
    placement,
    invalid: true
  };
  let resultTop;
  let resultLeft;
  let domNodeToAttachToRect;
  let positionedAncestor = {
    top: 0,
    left: 0
  };

  if (options.domNodeToAttachTo) {
    domNodeToAttachToRect = getBoundingClientRectWithDefaults(options.domNodeToAttachTo);

    if (options.domNodeToAttachTo.offsetParent) {
      positionedAncestor = getBoundingClientRectWithDefaults(options.domNodeToAttachTo.offsetParent);
    }
  }

  const nearestPositionedElement = getNearestPositionedParent(flyoutTrigger);
  const nearestRect = getBoundingClientRectWithDefaults(nearestPositionedElement); // above is for result initialization

  const placementToValidate = candidatePlacement.slice();
  let index;

  while (result.invalid && placementToValidate.length >= 0) {
    let checkTop = startingTop;
    let checkLeft = startingLeft;
    const extraH = (containerRect.width - triggerRect.width) / 2;
    const extraV = (containerRect.height - triggerRect.height) / 2;

    switch (placement) {
      case _flyoutPosition.TOP:
      case _flyoutPosition.TOP_LEFT:
      case _flyoutPosition.TOP_RIGHT_START:
        checkTop = validateSpace(_flyoutPosition.TOP, startingTop, containerRect, triggerRect, options);
        checkLeft += triggerRect.width - containerRect.width;
        placement !== _flyoutPosition.TOP_RIGHT_START && (checkLeft -= triggerRect.width);
        checkLeft += shiftArrow;

        if (checkTop > 0 && checkLeft > 0 || options.final === true) {
          // Do the calculation here
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top) - containerRect.height;
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left) + triggerRect.width;
          resultLeft -= containerRect.width;
          placement !== _flyoutPosition.TOP_RIGHT_START && (resultLeft -= triggerRect.width);
          resultLeft += shiftArrow;
          if (arrowRect) resultTop -= Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultTop -= options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement,
            invalid: false
          };
        } else {
          // remove placement that is already validated
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1); // get another placement to check

          [placement] = placementToValidate;
        }

        break;

      case _flyoutPosition.TOP_RIGHT:
      case _flyoutPosition.TOP_LEFT_START:
        checkTop = validateSpace(_flyoutPosition.TOP, startingTop, containerRect, triggerRect, options);
        checkLeft += containerRect.width;
        placement !== _flyoutPosition.TOP_LEFT_START && (checkLeft += triggerRect.width);
        checkLeft -= shiftArrow;

        if (checkTop > 0 && checkLeft < widthToCheck || options.final === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top) - containerRect.height;
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left);
          placement !== _flyoutPosition.TOP_LEFT_START && (resultLeft += triggerRect.width);
          resultLeft -= shiftArrow;
          if (arrowRect) resultTop -= Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultTop -= options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          [placement] = placementToValidate;
        }

        break;

      case _flyoutPosition.TOP_CENTRED:
        checkTop = validateSpace(_flyoutPosition.TOP, startingTop, containerRect, triggerRect, options);

        if (checkTop > 0 && checkLeft - extraH > 0 && checkLeft + triggerRect.width + extraH < widthToCheck || options.final === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top) - containerRect.height;
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left) + triggerRect.width / 2;
          resultLeft -= containerRect.width / 2;
          if (arrowRect) resultTop -= Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultTop -= options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          [placement] = placementToValidate;
        }

        break;

      case _flyoutPosition.BOTTOM:
      case _flyoutPosition.BOTTOM_LEFT:
      case _flyoutPosition.BOTTOM_RIGHT_START:
        checkTop = validateSpace(_flyoutPosition.BOTTOM, startingTop, containerRect, triggerRect, options);
        checkLeft += triggerRect.width - containerRect.width;
        placement !== _flyoutPosition.BOTTOM_RIGHT_START && (checkLeft -= triggerRect.width);
        checkLeft += shiftArrow;

        if (heightToCheck > checkTop && checkLeft > 0 || options.final === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top) + triggerRect.height;
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left) + triggerRect.width;
          resultLeft -= containerRect.width;
          placement !== _flyoutPosition.BOTTOM_RIGHT_START && (resultLeft -= triggerRect.width);
          resultLeft += shiftArrow;
          if (arrowRect) resultTop += Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultTop += options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          [placement] = placementToValidate;
        }

        break;

      case _flyoutPosition.BOTTOM_RIGHT:
      case _flyoutPosition.BOTTOM_LEFT_START:
        checkTop = validateSpace(_flyoutPosition.BOTTOM, startingTop, containerRect, triggerRect, options);
        checkLeft += containerRect.width;
        placement !== _flyoutPosition.BOTTOM_LEFT_START && (checkLeft += triggerRect.width);
        checkLeft -= shiftArrow;

        if (heightToCheck > checkTop && checkLeft < widthToCheck || options.final === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top) + triggerRect.height;
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left);
          placement !== _flyoutPosition.BOTTOM_LEFT_START && (resultLeft += triggerRect.width);
          resultLeft -= shiftArrow;
          if (arrowRect) resultTop += Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultTop += options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          [placement] = placementToValidate;
        }

        break;

      case _flyoutPosition.BOTTOM_CENTRED:
        checkTop = validateSpace(_flyoutPosition.BOTTOM, startingTop, containerRect, triggerRect, options);

        if (heightToCheck > checkTop && checkLeft - extraH > 0 && checkLeft + triggerRect.width + extraH < widthToCheck || options.final === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top) + triggerRect.height;
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left) + triggerRect.width / 2;
          resultLeft -= containerRect.width / 2;
          if (arrowRect) resultTop += Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultTop += options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          [placement] = placementToValidate;
        }

        break;

      case _flyoutPosition.LEFT:
      case _flyoutPosition.LEFT_BOTTOM:
        checkLeft = validateSpace(_flyoutPosition.LEFT, startingLeft, containerRect, triggerRect, options);
        checkTop += triggerRect.height;
        checkTop -= shiftArrow;
        checkTop += containerRect.height;

        if (checkLeft > 0 && heightToCheck > checkTop || options.final === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top);
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left) - containerRect.width;
          resultTop += triggerRect.height;
          resultTop -= shiftArrow;
          if (arrowRect) resultLeft -= Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultLeft -= options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          [placement] = placementToValidate;
        }

        break;

      case _flyoutPosition.LEFT_TOP:
        checkLeft = validateSpace(_flyoutPosition.LEFT, startingLeft, containerRect, triggerRect, options);
        checkTop -= containerRect.height - triggerRect.height;
        checkTop -= triggerRect.height;
        checkTop += shiftArrow;

        if (checkLeft > 0 && checkTop > 0 || options.final === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top) - containerRect.height;
          resultTop += shiftArrow;
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left) - containerRect.width;
          if (arrowRect) resultLeft -= Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultLeft -= options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          [placement] = placementToValidate;
        }

        break;

      case _flyoutPosition.LEFT_CENTRED:
        checkLeft = validateSpace(_flyoutPosition.LEFT, startingLeft, containerRect, triggerRect, options);

        if (checkLeft > 0 && checkTop - extraV > 0 && checkTop + triggerRect.height + extraV < heightToCheck || options.final === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top) - containerRect.height / 2;
          resultTop += triggerRect.height / 2;
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left) - containerRect.width;
          if (arrowRect) resultLeft -= Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultLeft -= options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          [placement] = placementToValidate;
        }

        break;

      case _flyoutPosition.RIGHT:
      case _flyoutPosition.RIGHT_BOTTOM:
        checkLeft = validateSpace(_flyoutPosition.RIGHT, startingLeft, containerRect, triggerRect, options);
        checkTop += triggerRect.height;
        checkTop -= shiftArrow;
        checkTop += containerRect.height;

        if (widthToCheck > checkLeft && heightToCheck > checkTop || options.final === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top);
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left) + triggerRect.width;
          resultTop += triggerRect.height;
          resultTop -= shiftArrow;
          if (arrowRect) resultLeft += Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultLeft += options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          [placement] = placementToValidate;
        }

        break;

      case _flyoutPosition.RIGHT_TOP:
        checkLeft = validateSpace(_flyoutPosition.RIGHT, startingLeft, containerRect, triggerRect, options);
        checkTop -= containerRect.height - triggerRect.height;
        checkTop -= triggerRect.height;
        checkTop += shiftArrow;

        if (widthToCheck > checkLeft && checkTop > 0 || options.final === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top) - containerRect.height;
          resultTop += shiftArrow;
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left) + triggerRect.width;
          if (arrowRect) resultLeft += Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultLeft += options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          [placement] = placementToValidate;
        }

        break;

      case _flyoutPosition.RIGHT_CENTRED:
        checkLeft = validateSpace(_flyoutPosition.RIGHT, startingLeft, containerRect, triggerRect, options);

        if (widthToCheck > checkLeft && checkTop - extraV > 0 && checkTop + triggerRect.height + extraV < heightToCheck || options.final === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top) - containerRect.height / 2;
          resultTop += triggerRect.height / 2;
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left) + triggerRect.width;
          if (arrowRect) resultLeft += Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultLeft += options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          [placement] = placementToValidate;
        }

        break;

      default:
        return {
          top: 0,
          left: 0,
          placement,
          invalid: true
        };
    }
  }

  return result;
} // Determines the position for flyout, while finding a valid placement and checking if there is space to place the flyout


function getSpecs(flyoutTrigger, flyoutContainer, placement, options, candidatePlacement) {
  if (flyoutTrigger.getBoundingClientRect === undefined || flyoutContainer.getBoundingClientRect === undefined) {
    return invalidSpecs;
  } // Check if a valid placement that fits in the current window the page exists


  options.body = 'window';
  let validPlacement = getValidPlacement(flyoutTrigger, flyoutContainer, placement, candidatePlacement, options); // If no valid placement fits in the current window, check if there exists a valid placement on the page (i.e. will not be fully visible in the window, but will fit on the page)

  if (validPlacement.invalid) {
    options.body = 'page';
    validPlacement = getValidPlacement(flyoutTrigger, flyoutContainer, placement, candidatePlacement, options);
  } // if no valid placement anyway, display the flyout directly


  if (validPlacement.invalid) {
    options.final = true;
    validPlacement = getValidPlacement(flyoutTrigger, flyoutContainer, placement, candidatePlacement, options);
  }

  return validPlacement;
}

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(3);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _context = __webpack_require__(21);

var _utils = __webpack_require__(5);

var _Flyout = _interopRequireDefault(__webpack_require__(172));

var _dec, _class, _class2, _temp;

const {
  omit
} = _utils.lodash;
let ContextFlyout = (_dec = (0, _context.withContext)('theme'), _dec(_class = (_temp = _class2 = class ContextFlyout extends _react.Component {
  render() {
    const {
      theme,
      children
    } = this.props;
    const otherProps = omit(this.props, 'theme', 'children', 'className');
    return /*#__PURE__*/_react.default.createElement(_Flyout.default, (0, _extends2.default)({}, otherProps, {
      className: `${theme} ${this.props.className}`,
      ref: node => {
        this._flyout = node;
      }
    }), children);
  }

}, (0, _defineProperty2.default)(_class2, "propTypes", {
  theme: _propTypes.default.string,
  ..._Flyout.default.propTypes
}), (0, _defineProperty2.default)(_class2, "defaultProps", {
  className: ''
}), _temp)) || _class);
exports.default = ContextFlyout;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 61:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__61__;

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.POSITIONS = exports.RIGHT_BOTTOM = exports.RIGHT_CENTRED = exports.RIGHT_TOP = exports.RIGHT = exports.LEFT_BOTTOM = exports.LEFT_CENTRED = exports.LEFT_TOP = exports.LEFT = exports.BOTTOM_RIGHT = exports.BOTTOM_LEFT_START = exports.BOTTOM_CENTRED = exports.BOTTOM_RIGHT_START = exports.BOTTOM_LEFT = exports.BOTTOM = exports.TOP_RIGHT = exports.TOP_LEFT_START = exports.TOP_CENTRED = exports.TOP_RIGHT_START = exports.TOP_LEFT = exports.TOP = void 0;

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const TOP = 'top';
exports.TOP = TOP;
const TOP_LEFT = 'topLeft';
exports.TOP_LEFT = TOP_LEFT;
const TOP_RIGHT_START = 'topRightStart';
exports.TOP_RIGHT_START = TOP_RIGHT_START;
const TOP_CENTRED = 'topCentred';
exports.TOP_CENTRED = TOP_CENTRED;
const TOP_LEFT_START = 'topLeftStart';
exports.TOP_LEFT_START = TOP_LEFT_START;
const TOP_RIGHT = 'topRight';
exports.TOP_RIGHT = TOP_RIGHT;
const BOTTOM = 'bottom';
exports.BOTTOM = BOTTOM;
const BOTTOM_LEFT = 'bottomLeft';
exports.BOTTOM_LEFT = BOTTOM_LEFT;
const BOTTOM_RIGHT_START = 'bottomRightStart';
exports.BOTTOM_RIGHT_START = BOTTOM_RIGHT_START;
const BOTTOM_CENTRED = 'bottomCentred';
exports.BOTTOM_CENTRED = BOTTOM_CENTRED;
const BOTTOM_LEFT_START = 'bottomLeftStart';
exports.BOTTOM_LEFT_START = BOTTOM_LEFT_START;
const BOTTOM_RIGHT = 'bottomRight';
exports.BOTTOM_RIGHT = BOTTOM_RIGHT;
const LEFT = 'left';
exports.LEFT = LEFT;
const LEFT_TOP = 'leftTop';
exports.LEFT_TOP = LEFT_TOP;
const LEFT_CENTRED = 'leftCentred';
exports.LEFT_CENTRED = LEFT_CENTRED;
const LEFT_BOTTOM = 'leftBottom';
exports.LEFT_BOTTOM = LEFT_BOTTOM;
const RIGHT = 'right';
exports.RIGHT = RIGHT;
const RIGHT_TOP = 'rightTop';
exports.RIGHT_TOP = RIGHT_TOP;
const RIGHT_CENTRED = 'rightCentred';
exports.RIGHT_CENTRED = RIGHT_CENTRED;
const RIGHT_BOTTOM = 'rightBottom';
exports.RIGHT_BOTTOM = RIGHT_BOTTOM;
const POSITIONS = [TOP, TOP_LEFT, TOP_RIGHT_START, TOP_CENTRED, TOP_LEFT_START, TOP_RIGHT, BOTTOM, BOTTOM_LEFT, BOTTOM_RIGHT_START, BOTTOM_CENTRED, BOTTOM_LEFT_START, BOTTOM_RIGHT, LEFT, LEFT_TOP, LEFT_CENTRED, LEFT_BOTTOM, RIGHT, RIGHT_TOP, RIGHT_CENTRED, RIGHT_BOTTOM];
exports.POSITIONS = POSITIONS;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[322,0]]]);
});